import {RouteComponentProps} from "react-router";
import {useAllUsersQuery, useAnswersListQuery, UserAnswerObject} from "../../../../types.d";
import {Link} from "react-router-dom";
import * as React from "react";
import Select from 'react-select';
import {useState} from "react";
import {CardTypeId} from "../../../../utils/constants";
import {UsersSelectList} from "../../../partials/UsersSelectList";

export const UserStatsPage = (props: RouteComponentProps) => {
    const { match } = props;

    const [selectedUser, setSelectedUser] = useState<number>(null);
    const answers = useAnswersListQuery({
        skip: !selectedUser,
        fetchPolicy: 'network-only',
        variables: {
            userId: selectedUser
        }
    });

    const formattedAnswers = (answers.data != null) ? answers.data.answersList
        .reduce<{ [key: number]: UserAnswerObject[] }>(((previousValue, currentValue, currentIndex) => {
            const next = { ...previousValue };

            if (!next[currentValue.card.id]) {
                next[currentValue.card.id] = [];
            }

            next[currentValue.card.id].push(currentValue);

            return next;
        }), {}) : null;

    return <div className={'index-wrapper'}>
        <div className={'index-page'}>
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">
                        User Stats
                    </li>
                </ol>
            </nav>

            <UsersSelectList onSelect={setSelectedUser} />

            { answers.loading && <h2 className={'mt-5'}>Loading...</h2> }

            { answers.data && !answers.loading && (
                <table className={'table mt-5'}>
                    <thead>
                        <tr>
                            <th scope="col">ID</th>
                            <th scope="col">Date</th>
                            <th scope="col">Next Schedule</th>
                            <th scope="col">SM2</th>
                            <th scope="col">Direction</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                    { Object.keys(formattedAnswers).map(item => <AnswerBlockComponent
                        answers={formattedAnswers}
                        id={Number(item)}
                        key={item} />) }
                </table>
            ) }
        </div>
    </div>
};

const AnswerBlockComponent = ({ answers, id }: { answers: { [key: number]: UserAnswerObject[] }, id: number }) => {
    const list = answers[id];
    const first = list[0];

    return <>
        <tr style={{ background: '#f4f4f4' }}>
            <td>
                <h6 className="mb-0">{ first.card.id }</h6>
            </td>
            <td colSpan={5}>
                <h6 className="mb-0">
                    { first.card.cardType === CardTypeId.Vocabulary ? first.card.wordTranslation.sourceWord.lemma : 'Grammar Card' }
                </h6>
            </td>
        </tr>

        { list.map(answer => <AnswerComponent key={answer.id} answer={answer} />) }
    </>
};

const AnswerComponent = ({ answer }: { answer: UserAnswerObject }) => {
    const state = answer.state.length ? JSON.parse(answer.state) : {};
    const defaultInstruction = state?.instructions?.defaultInstruction;

    return <>
        <tr>
            <td rowSpan={answer.card.cardType === CardTypeId.Vocabulary ? 1 : 2}>
                {answer.id}
            </td>
            <td>
                {answer.date}
            </td>
            <td>
                {answer.nextShow}
            </td>
            <td className={defaultInstruction?.status !== '1' ? 'card-answer-text-gray' : ''}>
                Factor: { defaultInstruction?.factor } / Interval: { defaultInstruction?.interval } / Repetition: { defaultInstruction?.repetition } / Cycle: {defaultInstruction?.cycle}
            </td>
            <td>{ defaultInstruction?.inverted ? 1 : 0 }</td>
            <td className={`card-answer-${ answer.isSkipped ? 'gray' : answer.selfEvaluation }`}>
                { answer.isSkipped ? 'Skipped' : answer.selfEvaluation }
            </td>
        </tr>

        { answer.log && <tr>
            <td colSpan={5}>
                {answer.log}
            </td>
        </tr> }
    </>
};
